<template>
    <div>
        <!-- Loading -->
        <loading :active.sync="isLoading" :is-full-page="true"></loading>
        <v-container class="mt-10">
            <div
                    class="vhtml"
                    v-if="content !== 'not found'"
                    v-html="content[`detail_${lang}`]"
            ></div>
            <div v-else>
                Content not found, redirecting..
            </div>
        </v-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Loading from 'vue-loading-overlay';

    export default {
        components: {
            Loading
        },
        data: () => ({
            isLoading: false
        }),
        computed: {
          ...mapState({
              lang: state => state.Branch.lang,
              content: state => {
                  if (state.FreePage.content) {
                      return state.FreePage.content;
                  } else {
                      return 'not found';
                  }
              }
          })
        },
        async created() {
            this.isLoading = true;
            await this.$store.dispatch('FreePage/onGetFreePageData', this.$route.params.slug);
            this.isLoading = false;
            if (this.content === 'not found') {
                window.location = '/';
            }
        }
    }
</script>

<style scoped>

</style>
